<template>
  <div>
    <!-- UNCOMMENT THE CODE BELOW TO SHOW THE SLIDER WITH PRODUCTS IT WAS 
    AND GO AT THE END FIND COMMENTS UNCOMMENT THERE TOO AND UNCOMMENT THE CODE THERE TO TO ASSIGN COMPONENTS -->
    <div class="full-page-slider">
      <hooper class="h-full px-2" :autoPlay="true" :playSpeed="7000">
        <slide v-for="(slide, indx) in slides" :key="indx" :index="indx">
          <div class>
            <router-link :to="slide.description">
              <img class="mx-auto w-full" :src="slide.url_path" alt="Product Image" />
            </router-link> 
          </div>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </hooper>
    </div>

    <!-- categories -->
    <div class="flex flex-wrap cats-div justify-cats">
      
      <div
        class="lg:w-1/3 sm:w-full md:w-1/3 box zoom-in"
        v-for="category in categories"
        :key="category.id"
      >
        <div
          class="content-start p-2 text-center items-center justify-center relative "
          v-show="category.name != 'Sale'"
        >
          <router-link
            :to="{
              name: 'products',
              query: { category: category.slug },
            }"
          >
            <img class :src="category.url_path" alt />
            <div class="text">
              <p
                class="cats-name font-bold bg-gray-200 text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-gray-700"
              >{{ category.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- /categories -->

    <!-- products on sale -->
    <!-- <h1 class="uppercase text-center justify-center items-center font-bold text-lg">produkte zum verkauf</h1>
    <div class="flex flex-wrap">
      <div
        class="box lg:w-1/3 sm:w-full md:w-1/3"
        v-for="saleProduct in saleProducts"
        :key="saleProduct.id"
      >
        <div class="content-start p-2 text-center items-center justify-center relative">
          <router-link :to="{ name: 'product', params: { id: saleProduct.id }}">
            <img class :src="saleProduct.product_image" alt />
            <div class="text">
              <p
                class="font-bold bg-white text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-black"
              >{{ saleProduct.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div> -->
    <!-- /products on sale -->

    <!-- wohnen -->
    <h1 class="uppercase text-center font-bold text-lg mt-20 mb-2 cats-titulli">wohnen top serien</h1>
    <div class="flex flex-wrap justify-cats">
      <div
        class="box lg:w-1/3 sm:w-full md:w-1/3 zoom-in "
        v-for="wohnenBrand in wohnenBrands"
        :key="wohnenBrand.id"
      >
        <div class="content-start p-2 text-center items-center justify-center relative">
          <router-link
            :to="{
              name: 'products',
              query: { category: 'wohnen', brand: wohnenBrand.id },
            }"
          >
            <img class :src="wohnenBrand.url_path" alt />
            <div class="text">
              <p
                class="cats-name font-bold bg-white text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-black"
              >{{ wohnenBrand.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- /wohnen -->

    <!-- schlafzimmer -->
    <h1 class="uppercase text-center font-bold text-lg mt-20 mb-2 cats-titulli">SCHLAFZIMMER TOP SERIEN</h1>
    <div class="flex flex-wrap justify-cats">
      <div
        class="box lg:w-1/3 sm:w-full md:w-1/3 zoom-in"
        v-for="schlafzimmerBrand in schlafzimmerBrands"
        :key="schlafzimmerBrand.id"
      >
        <div class="content-start p-2 text-center items-center justify-center relative">
          <router-link
            :to="{
              name: 'products',
              query: { category: 'schlafzimmer', brand: schlafzimmerBrand.id },
            }"
          >
            <img class :src="schlafzimmerBrand.url_path" alt />
            <div class="text">
              <p
                class="cats-name font-bold bg-white text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-black"
              >{{ schlafzimmerBrand.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- /schlafzimmer -->

    <!-- badezimmer -->
    <h1 class="uppercase text-center font-bold text-lg  mt-20 mb-2 cats-titulli">BADEZIMMER TOP SERIEN</h1>
    <div class="flex flex-wrap justify-cats">
      <div
        class="box lg:w-1/3 sm:w-full md:w-1/3 zoom-in"
        v-for="badezimmerBrand in badezimmerBrands"
        :key="badezimmerBrand.id"
      >
        <div class="content-start p-2 text-center items-center justify-center relative">
          <router-link
            :to="{
              name: 'products',
              query: { category: 'badezimmer', brand: badezimmerBrand.id },
            }"
          >
            <img class :src="badezimmerBrand.url_path" alt />
            <div class="text">
              <p
                class="cats-name font-bold bg-white text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-black"
              >{{ badezimmerBrand.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- /badezimmer -->

    <!-- garderoben -->
    <h1 class="uppercase text-center font-bold text-lg mt-20 mb-2 cats-titulli">GARDEROBEN TOP SERIEN</h1>
    <div class="flex flex-wrap justify-cats">
      <div
        class="box lg:w-1/3 sm:w-full md:w-1/3 zoom-in"
        v-for="garderobeBrand in garderobeBrands"
        :key="garderobeBrand.id"
      >
        <div class="content-start p-2 text-center items-center justify-center relative">
          <router-link
            :to="{
              name: 'products',
              query: {
                category: 'flurmobel-dielenmobe',
                brand: garderobeBrand.id,
              },
            }"
          >
            <img class :src="garderobeBrand.url_path" alt />
            <div class="text">
              <p
                class="cats-name font-bold bg-white text-gray-900 text-lg py-2 bg-transparent uppercase hover:text-black"
              >{{ garderobeBrand.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- /garderoben -->

    <!-- services -->
    <!-- services -->
    <div class="bg-teal-200 mx-2">
      <h1 class="text-center py-2">
        <span v-html="testHeader" class="text-gray-900 font-semibold font-size-400"></span>
      </h1>
    </div>
    <div class="flex flex-wrap bg-teal-200 shadow-lg mx-2">
      <div class="p-20 sm:p-4 lg:w-1/4 md:w-1/2 sm:w-full text-center items-center content-center">
        <router-link to="/transport-gratis" class="text-teal-400 text-sm" target="_blank">
          <img
            src="@/assets/images/shipped.png"
            class="text-center lg:w-20 sm:w-32 mx-auto size-400"
            alt="Shipped"
          />
          <h3 class="font-semibold text-gray-800 uppercase">Kostenloser Versand</h3>
          <p
            class="text-sm text-gray-500">Kostenloser Versand überall in Deutschland (Deutsches Festland).</p>
        </router-link>
      </div>
      <div class="p-20 sm:p-4 lg:w-1/4 md:w-1/2 sm:w-full text-center items-center content-center">
        <router-link to="/kunden" class="text-teal-400 text-sm" target="_blank">
          <img
            src="@/assets/images/customer-service.png"
            class="text-center lg:w-20 sm:w-32 mx-auto size-400"
            alt="Shipped"
          />
          <h3 class="font-semibold text-gray-800">KUNDENSERVICE</h3>
          <p class="text-sm text-gray-500">
            Mo-Fr: 08:00-18:00 Uhr
            <span></span>
          </p>
        </router-link>
      </div>
      <div class="p-20 sm:p-4 lg:w-1/4 md:w-1/2 sm:w-full text-center items-center content-center">
        <router-link to="/sichere" class="text-teal-400 text-sm" target="_blank">
          <img
            src="@/assets/images/debit-card.png"
            class="text-center lg:w-20 sm:w-32 mx-auto size-400"
            alt="Shipped"
          />
          <h3 class="font-semibold text-gray-800">Sichere Online-Zahlung</h3>
          <p class="text-sm text-gray-500">Sicher einkaufen</p>
        </router-link>
      </div>
      <div class="p-20 sm:p-4 lg:w-1/4 md:w-1/2 sm:w-full text-center items-center content-center">
        <router-link to="/versand" class="text-teal-400 text-sm" target="_blank">
          <img
            src="@/assets/images/refund.png"
            class="text-center lg:w-20 sm:w-32 mx-auto size-400"
            alt="Shipped"
          />
          <h3 class="font-semibold text-gray-800">VERSANDBEDINGUNGEN</h3>
          <p class="text-sm text-gray-500">14 Tagen Wiederrufsrecht</p>
        </router-link>
      </div>
    </div>
    <!-- /services -->
    <!-- /services -->

    <div class="mx-2">
      <p class="py-6">
        <span v-html="testBody" class="text-left text-gray-900 font-semibold">
        
        </span>
      </p>
    </div>

    <!-- footer content -->
    <div class="mx-2">
      <span v-html="footerContent" class="text-sm text-gray-800"></span>
    </div>
    <!-- /footer content -->
  </div>
</template>

<script>
//UNCOMMENT THERE TOO
import { 
  Hooper, 
  Slide, 
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from "hooper";

import "hooper/dist/hooper.css";
import axios from "axios";

export default {
  //UNCOMMENT THERE TOO
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data() {
    return {
      slides: [],
      categories: [],
      saleProducts: [],
      wohnenBrands: [],
      schlafzimmerBrands: [],
      badezimmerBrands: [],
      garderobeBrands: [],
      footerContent: "",
      testHeader: "",
      testBody: "",
    };
  },
  created() {
    this.getSliderImages();
    this.getTopCategories();
    // this.getSaleProducts();
    this.getWohnenBrands();
    this.getSchlafzimmerBrands();
    this.getBadezimmerBrands();
    this.getGarderobeBrands();
    this.getContent();
  },
  methods: {
    getSliderImages() {
      axios.get(`${process.env.VUE_APP_API}/sliders`).then((response) => {
        this.slides = response.data.data;
        // console.log(response);
      });
    },
    getTopCategories() {
      axios
        .get(`${process.env.VUE_APP_API}/categories-parent`)
        .then((response) => {
          // console.log(response);
          this.categories = response.data;
          // console.log(this.categories);
        });
    },
    // getSaleProducts() {
    //   axios.get(`${process.env.VUE_APP_API}/top-sale-products`).then((response) => {
    //     // console.log(response.data.data)
    //     this.saleProducts = response.data.data;
    //   })
    // },
    getWohnenBrands() {
      axios.get(`${process.env.VUE_APP_API}/category/2`).then((response) => {
        this.wohnenBrands = response.data;
      });
    },
    getSchlafzimmerBrands() {
      axios.get(`${process.env.VUE_APP_API}/category/3`).then((response) => {
        this.schlafzimmerBrands = response.data;
      });
    },
    getBadezimmerBrands() {
      axios.get(`${process.env.VUE_APP_API}/category/7`).then((response) => {
        this.badezimmerBrands = response.data;
      });
    },
    getGarderobeBrands() {
      axios.get(`${process.env.VUE_APP_API}/category/6`).then((response) => {
        this.garderobeBrands = response.data;
      });
    },
    getContent() {
      axios
        .get(`${process.env.VUE_APP_API}/homepage-texts`)
        .then((response) => {
          response.data.data.map((item) => {
            if (item.name === "Icons_Transport") {
              this.testHeader = item.description;
            }
            if (item.name === "Description_Main") {
              this.testBody = item.description;
            }
          });
        });
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 470px) {
  .cats-div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .box {
    flex-basis: 100%;
    max-width: 100%;
  }
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .centered-heading {
    text-align: center;
  }
  .mx-2 {
    margin-left: 0.5rem;
    margin-right: 1.1rem;
}
  .justify-cats {
    display: flex;
    justify-content: center;
  }
  
  .box {
    width: 100%;
  }
  .full-page-slider {
    height: 100%;
  }

  .full-page-slider .hooper {
    height: 100%;
  }
}

.justify-cats{
  justify-content: center;
}
.zoom-in{
  margin-top: 10px;
  margin-right: 10px;
  transition: transform 0.5s ease;
  width: 30%;
}

.zoom-in:hover {
  transform: scale(1.03);
}
.box {
  position: relative;
  display: inline-block;
}
.box .text {
  position: absolute;
  z-index: 999;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  width: 60%;
}

.text {
  opacity: 0.8;
}

@media(max-width:450px){
  .font-size-400{
    font-size: 13px;
  }
}

@media(max-width:426px){
  .font-size-400{
    font-size: 14px;
  }
}

@media(max-width:450px){
  .cats-div{
    padding: 10px;

  }
  .size-400{
    width: 50%;
  }
 
  /* .cats-titulli{
    border-bottom: 1px solid #edebeb;
  } */
}
/*
  .cats-name{
    font-size: 9px;
  }

  .box .text{
    width:50%;
  }

  .tawk-min-container{
    width:50%;
  }
} */
/* .hooper-track {
    transition: none !important;
}

.hooper-slide, .hooper-slide.is-prev, .hooper-slide.is-next {
    transition: all 1s ease-in-out;
    opacity: 0 !important;
}

.hooper-slide.is-active {
    opacity: 1 !important;
} */

  .height-width-slider{
    height: 500px;
  }

</style>